import React, { CSSProperties } from "react";
import colors from "../styles/colors";
import { Box } from "@amzn/awsui-components-react";
import { WIKI_LINK_LABEL, WIKI_LINK_URL } from "../constants/common";

const footerStyle: CSSProperties = {
  paddingTop: "15px",
  paddingBottom: "15px",
  width: "100%",
  borderTop: "1px solid #eaeded",
  textAlign: "center",
  backgroundColor: colors.lightContainerBackground,
};

const footerLinkStyle: CSSProperties = {
  padding: "0px",
  fontSize: "14px",
  color: colors.linkTextColor,
  cursor: "pointer",
};

const openInNewTab = (url: string) => {
  window.open(url, "_blank");
};

const navigateToUserDocs = () => {
  openInNewTab(WIKI_LINK_URL);
};

function Footer() {
  return (
    <div
      id="app-footer"
      data-testid="app-footer"
      style={footerStyle}
      className="awsui awsui-polaris-dark-mode"
    >
      <Box>
        <div>
          <span
            data-testid="footer-wiki-link"
            style={footerLinkStyle}
            onClick={navigateToUserDocs}
          >
            {WIKI_LINK_LABEL}
          </span>
        </div>
      </Box>
    </div>
  );
}

export default Footer;
